
export default {
  name: 'Frame',
  data() {
    return {
      redirectUrl: null,
    }
  },
  computed: {
    iframeUrl() {
      const url = this.$route.query.url || this.$route.query.src
      if (!url) return null
      
      // URL'i decode et
      try {
        return decodeURIComponent(url)
      } catch (e) {
        return url
      }
    },
  },
  mounted() {
    this.setupMessageListener()
  },
  beforeDestroy() {
    this.removeMessageListener()
  },
  methods: {
    setupMessageListener() {
      // PostMessage listener ekle
      this.messageHandler = (event) => {
        try {
          // Güvenlik: event.origin kontrolü yapılabilir
          let data = event.data
          
          // String ise parse et
          if (typeof data === 'string') {
            try {
              data = JSON.parse(data)
            } catch (e) {
              // JSON değilse string olarak kullan
            }
          }

          // Redirect mesajını kontrol et
          if (data && data.type === 'redirect' && data.url) {
            this.handleRedirect(data.url)
          }
        } catch (e) {
          console.error('PostMessage işleme hatası:', e)
        }
      }

      window.addEventListener('message', this.messageHandler)
    },
    removeMessageListener() {
      if (this.messageHandler) {
        window.removeEventListener('message', this.messageHandler)
      }
    },
    handleRedirect(url) {
      // URL'i kaydet
      this.redirectUrl = url
      
      // Kullanıcıyı yönlendir
      if (url) {
        window.location.href = url
      }
    },
  },
  head() {
    return {
      title: "Frame Payment Page",
      meta: [
        { name: 'description', content: 'Frame Payment Page' },
        { name: 'robots', content: 'noindex, nofollow' },
      ],
    }
  },
}
